import { atom } from 'recoil';
import { MODAL_KEYS } from '../../constants';

type Modal = {
  shouldShow: boolean;
  current: MODAL_KEYS | null;
};

export const ModalState = atom<Modal>({
  key: 'MODAL_STATE',
  default: { shouldShow: false, current: null },
});
